import Tooltip, {AbsoluteTooltip} from "./ui/tooltip";

export default Tooltip;
export {AbsoluteTooltip};
